import { ArticleDto, ClientDto, LabelDto, SiteDto } from '../../../api/ClientApi';

export const isArticleSelected = (article: ArticleDto, searchToken: string): boolean => {
    const searchTokens = searchToken
        .toLowerCase()
        .split(' ')
        .filter((a) => a !== '');
    let numOfFinds = 0;
    let tokens = getArticleOptionString(article)
        .toLocaleLowerCase()
        .split(' ')
        .filter((a) => a !== '');

    searchTokens.forEach((st) => {
        if (st !== '') {
            const tokenIndex = tokens?.findIndex((mt) => mt.includes(st));

            if (tokenIndex !== undefined && tokenIndex >= 0 && tokens) {
                tokens = [...tokens?.slice(0, tokenIndex), ...tokens.slice(tokenIndex + 1, tokens?.length)];
                numOfFinds++;
            }
        } else {
            numOfFinds++;
        }
    });

    return numOfFinds === searchTokens.length && tokens.length === 0;
};

export const filterSelectedArticles = (articles: string[], searchToken: string): string[] => {
    const searchTokens = searchToken
        .toLowerCase()
        .split(' ')
        .filter((a) => a !== '');

    const newArray = articles.filter((article) => {
        let numOfFinds = 0;
        let tokens = article
            .toLowerCase()
            .split(' ')
            .filter((a) => a !== '');

        searchTokens.forEach((st) => {
            if (st !== '') {
                const tokenIndex = tokens?.findIndex((t) => t.includes(st));

                if (tokenIndex !== undefined && tokenIndex >= 0 && tokens) {
                    tokens = [...tokens?.slice(0, tokenIndex), ...tokens.slice(tokenIndex + 1, tokens?.length)];
                    numOfFinds++;
                }
            } else {
                numOfFinds++;
            }
        });

        return numOfFinds === searchTokens.length;
    });

    return newArray;
};

export const getArticleOptionString = (article?: ArticleDto): string => {
    if (!article) {
        return '';
    }
    return (
        (article.title ?? '') +
        ' (' +
        (article.manufacturer ?? '') +
        ') - ' +
        (article.innerCode ?? '') +
        ', ' +
        (article.outterCode ?? '')
    );
};

export const isClientSelected = (client: ClientDto, searchToken: string): boolean => {
    const searchTokens = searchToken
        .toLowerCase()
        .split(' ')
        .filter((a) => a !== '');
    let numOfFinds = 0;
    let tokens = getClientOptionString(client)
        .toLocaleLowerCase()
        .split(' ')
        .filter((a) => a !== '');

    searchTokens.forEach((st) => {
        if (st !== '') {
            const tokenIndex = tokens?.findIndex((mt) => mt.includes(st));

            if (tokenIndex !== undefined && tokenIndex >= 0 && tokens) {
                tokens = [...tokens?.slice(0, tokenIndex), ...tokens.slice(tokenIndex + 1, tokens?.length)];
                numOfFinds++;
            }
        } else {
            numOfFinds++;
        }
    });

    return numOfFinds === searchTokens.length && tokens.length === 0;
};

export const filterSelectedClients = (clients: string[], searchToken: string): string[] => {
    const searchTokens = searchToken
        .toLowerCase()
        .split(' ')
        .filter((a) => a !== '');

    const newArray = clients.filter((article) => {
        let numOfFinds = 0;
        let tokens = article
            .toLowerCase()
            .split(' ')
            .filter((a) => a !== '');

        searchTokens.forEach((st) => {
            if (st !== '') {
                const tokenIndex = tokens?.findIndex((t) => t.includes(st));

                if (tokenIndex !== undefined && tokenIndex >= 0 && tokens) {
                    tokens = [...tokens?.slice(0, tokenIndex), ...tokens.slice(tokenIndex + 1, tokens?.length)];
                    numOfFinds++;
                }
            } else {
                numOfFinds++;
            }
        });

        return numOfFinds === searchTokens.length;
    });

    return newArray;
};

export const getClientOptionString = (client?: ClientDto): string => {
    if (!client) {
        return '';
    }
    return (client.shortName ?? '') + ', ' + (client.name ?? '');
};

export const isSiteSelected = (site: SiteDto, searchToken: string): boolean => {
    const searchTokens = searchToken
        .toLowerCase()
        .split(' ')
        .filter((a) => a !== '');
    let numOfFinds = 0;
    let tokens = getSiteOptionString(site)
        .toLocaleLowerCase()
        .split(' ')
        .filter((a) => a !== '');

    searchTokens.forEach((st) => {
        if (st !== '') {
            const tokenIndex = tokens?.findIndex((mt) => mt.includes(st));

            if (tokenIndex !== undefined && tokenIndex >= 0 && tokens) {
                tokens = [...tokens?.slice(0, tokenIndex), ...tokens.slice(tokenIndex + 1, tokens?.length)];
                numOfFinds++;
            }
        } else {
            numOfFinds++;
        }
    });

    return numOfFinds === searchTokens.length && tokens.length === 0;
};

export const filterSelectedSites = (sites: string[], searchToken: string): string[] => {
    const searchTokens = searchToken
        .toLowerCase()
        .split(' ')
        .filter((a) => a !== '');

    const newArray = sites.filter((site) => {
        let numOfFinds = 0;
        let tokens = site
            .toLowerCase()
            .split(' ')
            .filter((a) => a !== '');

        searchTokens.forEach((st) => {
            if (st !== '') {
                const tokenIndex = tokens?.findIndex((t) => t.includes(st));

                if (tokenIndex !== undefined && tokenIndex >= 0 && tokens) {
                    tokens = [...tokens?.slice(0, tokenIndex), ...tokens.slice(tokenIndex + 1, tokens?.length)];
                    numOfFinds++;
                }
            } else {
                numOfFinds++;
            }
        });

        return numOfFinds === searchTokens.length;
    });

    return newArray;
};

export const getSiteOptionString = (site?: SiteDto): string => {
    if (!site) {
        return '';
    }
    return (site.name ?? '') + ', ' + (site.locationInfo?.address ?? '');
};

export const isLabelSelected = (label: LabelDto, searchToken: string): boolean => {
    const searchTokens = searchToken
        .toLowerCase()
        .split(' ')
        .filter((a) => a !== '');
    let numOfFinds = 0;
    let tokens = getLabelOptionString(label)
        .toLowerCase()
        .split(' ')
        .filter((a) => a !== '');

    if (tokens.length !== searchTokens.length) {
        return false;
    }

    searchTokens.forEach((st) => {
        if (st !== '') {
            const tokenIndex = tokens?.findIndex((mt) => mt === st);

            if (tokenIndex !== undefined && tokenIndex >= 0 && tokens) {
                tokens = [...tokens?.slice(0, tokenIndex), ...tokens.slice(tokenIndex + 1, tokens?.length)];
                numOfFinds++;
            }
        } else {
            numOfFinds++;
        }
    });

    return numOfFinds === searchTokens.length && tokens.length === 0;
};

export const filterSelectedLabels = (labels: string[], searchToken: string): string[] => {
    const searchTokens = searchToken
        .toLowerCase()
        .split(' ')
        .filter((a) => a !== '');

    const newArray = labels.filter((label) => {
        let numOfFinds = 0;
        let tokens = label
            .toLowerCase()
            .split(' ')
            .filter((a) => a !== '');

        searchTokens.forEach((st) => {
            if (st !== '') {
                const tokenIndex = tokens?.findIndex((t) => t.includes(st));

                if (tokenIndex !== undefined && tokenIndex >= 0 && tokens) {
                    tokens = [...tokens?.slice(0, tokenIndex), ...tokens.slice(tokenIndex + 1, tokens?.length)];
                    numOfFinds++;
                }
            } else {
                numOfFinds++;
            }
        });

        return numOfFinds === searchTokens.length;
    });

    return newArray;
};

export const getLabelOptionString = (label?: LabelDto): string => {
    if (!label) {
        return '';
    }
    return label.title ?? '';
};
